import { MenuItem, TextField } from '@mui/material';
import { BackgroundColors } from '@strength/domain';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ColorInput(props: {
  value?: string;
  onChange?: (value: string) => void;
}) {
  const { t } = useTranslation();
  const [selectedColor, setSelectedColor] = useState(props.value ?? '');

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedColor(event.target.value);
    props.onChange?.(event.target.value);
  };

  return (
    <TextField
      label={t('color')}
      select
      value={selectedColor}
      onChange={handleChange}
    >
      {BackgroundColors.map((color) => (
        <MenuItem key={color} value={color}>
          <div
            style={{
              backgroundColor: color,
              borderRadius: '50%',
              width: 20,
              height: 20,
              margin: 2,
            }}
          />
        </MenuItem>
      ))}
    </TextField>
  );
}
